import { CardDeckVariant, CreateCardDeckVariantData } from "@olagg/db-types"
import { AdminCardDecksVariantsEndpoints } from "../endpoints/adminEndpoints"
import { fetcher } from "../fetcher"
import { useToast } from "@chakra-ui/react"
import { useQ } from "./useQ"
import { useState } from "react"

export const useAdminCardDecksVariants = (deckId: string | number, traitId: string | number) => {
  const toast = useToast();
  const [variant, setVariant] = useState<CardDeckVariant>();

  const response = useQ<{variants: CardDeckVariant[]}>(AdminCardDecksVariantsEndpoints.list(deckId, traitId));

  const success_toast = (description: string) => {
    toast({
      title: 'Variante de Rasgo',
      colorScheme: 'olaggPink',
      status: 'success',
      description,
      position: 'bottom-right'
    });
  }
  
  const error_toast = (error: any) => {
    toast({
      title: 'Error',
      colorScheme: 'olaggYellow',
      status: 'error',
      description: error.errors || error.message,
      position: 'bottom-right'
    });
  }

  const createVariant = async (data: CreateCardDeckVariantData, callback?: () => void) => {
    return await fetcher(AdminCardDecksVariantsEndpoints.create(deckId, traitId, { variant: data }))
      .then(() => {
        success_toast('Variante creada con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const updateVariant = async (variantId: string | number, data: Partial<CreateCardDeckVariantData>, callback?: () => void) => {
    return await fetcher(AdminCardDecksVariantsEndpoints.update(deckId, traitId, variantId, { variant: data }))
      .then(() => {
        success_toast('Variante actualizada con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const deleteVariant = async (variantId: string | number) => (
    fetcher(AdminCardDecksVariantsEndpoints.delete(deckId, traitId, variantId))
      .then(() => {
        success_toast('Variante eliminada con éxito');
        response.mutate();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  )

  const find = (variantId: string | number) => {
    fetcher(AdminCardDecksVariantsEndpoints.show(deckId, traitId, variantId))
      .then(res => setVariant(res.variant))
  }

  return {
    ...response,
    variant,
    find,
    createVariant,
    updateVariant,
    deleteVariant,
  }
} 